<template>
  <aside class="notefie-dashboard-panel bg-linear-gray notefie-dashboard-panel-pinned">
    <div class="sidenav-header">
      <router-link class="notefie-dashboard__home" to="/">
        <img
          src="/src/assets/img/logo-pink.png"
          class="notefie-dashboard__logo"
          alt="Notefie logo"
        />
        <span class="notefie-dashboard__title">Portal</span>
      </router-link>
      <div class="notefie-dashboard__navigation">
        <ul>
          <li>
            <h6 class="text-white font-bold mt-4 pl-4 text-sm">Dashboard</h6>
          </li>
          <!-- Main Dashboard -->
          <sidenav-item
            v-if="isNavigationItemEnabled('dashboard')"
            :to="getNavigationItem('dashboard')?.path || '/'"
            :text="getNavigationItem('dashboard')?.text || ''"
          >
            <DashboardFilled />
          </sidenav-item>
          <!-- Profile -->
          <sidenav-item
            v-if="isNavigationItemEnabled('profile')"
            :to="getNavigationItem('profile')?.path || '/'"
            :text="getNavigationItem('profile')?.text || ''"
          >
            <user-alt />
          </sidenav-item>

          <!-- Customers -->
          <sidenav-item
            v-if="isNavigationItemEnabled('customers')"
            :to="getNavigationItem('customers')?.path || '/'"
            :text="getNavigationItem('customers')?.text || ''"
          >
            <users />
          </sidenav-item>

          <!-- Admin Users -->
          <sidenav-item
            v-if="isNavigationItemEnabled('adminUsers')"
            :to="getNavigationItem('adminUsers')?.path || '/'"
            :text="getNavigationItem('adminUsers')?.text || ''"
          >
            <AdminPanelSettingsOutlined />
          </sidenav-item>

          <!-- Web Users -->
          <sidenav-item
            v-if="isNavigationItemEnabled('webUsers')"
            :to="getNavigationItem('webUsers')?.path || '/'"
            :text="getNavigationItem('webUsers')?.text || ''"
          >
            <PeopleAltRound />
          </sidenav-item>

          <!-- Token Inspector -->
          <sidenav-item
            v-if="isNavigationItemEnabled('tokenInspector')"
            :to="getNavigationItem('tokenInspector')?.path || '/'"
            :text="getNavigationItem('tokenInspector')?.text || ''"
          >
            <Key />
          </sidenav-item>
          <!-- Devices -->
          <sidenav-collapse-item
            v-if="isNavigationItemEnabled('devices')"
            refer="devices"
            mini-icon="U"
            :text="getNavigationItem('devices')?.text || ''"
            :activePaths="[
              getNavigationItem('devices')?.children?.endDevices?.path || '',
              getNavigationItem('devices')?.children?.receivingDevices?.path || ''
            ]"
          >
            <ImportantDevicesFilled />
            <template #nav-child-item>
              <sidenav-item
                v-if="getNavigationItem('devices')?.children?.endDevices?.enabled"
                :to="getNavigationItem('devices')?.children?.endDevices?.path || '/'"
                :text="getNavigationItem('devices')?.children?.endDevices?.text || ''"
              >
                <DevicesOtherTwotone />
              </sidenav-item>
              <sidenav-item
                v-if="getNavigationItem('devices')?.children?.receivingDevices?.enabled"
                :to="getNavigationItem('devices')?.children?.receivingDevices?.path || '/'"
                :text="getNavigationItem('devices')?.children?.receivingDevices?.text || ''"
              >
                <ImportantDevicesOutlined />
              </sidenav-item>
            </template>
          </sidenav-collapse-item>
          <!-- Licenses -->
          <sidenav-collapse-item
            v-if="isNavigationItemEnabled('licenses')"
            refer="licenses"
            mini-icon="U"
            :text="getNavigationItem('licenses')?.text || ''"
            :activePaths="[
              getNavigationItem('licenses')?.children?.androidScreens?.path || '',
              getNavigationItem('licenses')?.children?.promoCodes?.path || ''
            ]"
          >
            <License />
            <template #nav-child-item>
              <sidenav-item
                v-if="getNavigationItem('licenses')?.children?.androidScreens?.enabled"
                :to="getNavigationItem('licenses')?.children?.androidScreens?.path || '/'"
                :text="getNavigationItem('licenses')?.children?.androidScreens?.text || ''"
              >
                <Android />
              </sidenav-item>
              <sidenav-item
                v-if="getNavigationItem('licenses')?.children?.promoCodes?.enabled"
                :to="getNavigationItem('licenses')?.children?.promoCodes?.path || '/'"
                :text="getNavigationItem('licenses')?.children?.promoCodes?.text || ''"
              >
                <Qrcode />
              </sidenav-item>
            </template>
          </sidenav-collapse-item>
          <!-- Serial Numbers -->
          <sidenav-item
            v-if="isNavigationItemEnabled('serialNumbers')"
            :to="getNavigationItem('serialNumbers')?.path || '/'"
            :text="getNavigationItem('serialNumbers')?.text || ''"
          >
            <NumbersFilled />
          </sidenav-item>

          <!-- Billing -->
          <sidenav-item
            v-if="isNavigationItemEnabled('billing')"
            :to="getNavigationItem('billing')?.path || '/'"
            :text="getNavigationItem('billing')?.text || ''"
          >
            <MoneyBill />
          </sidenav-item>

          <!-- MongoDB -->
          <sidenav-item
            v-if="isNavigationItemEnabled('mongodb')"
            :to="getNavigationItem('mongodb')?.path || '/'"
            :text="getNavigationItem('mongodb')?.text || ''"
          >
            <Database />
          </sidenav-item>

          <!-- Reports -->
          <sidenav-collapse-item
            v-if="isNavigationItemEnabled('reports')"
            refer="reports"
            mini-icon="U"
            :text="getNavigationItem('reports')?.text || ''"
            :activePaths="[
              getNavigationItem('reports')?.children?.reportsDisplay?.path || '',
              getNavigationItem('reports')?.children?.reportsEmail?.path || ''
            ]"
          >
            <License />
            <template #nav-child-item>
              <sidenav-item
                v-if="getNavigationItem('reports')?.children?.reportsDisplay?.enabled"
                :to="getNavigationItem('reports')?.children?.reportsDisplay?.path || '/'"
                :text="getNavigationItem('reports')?.children?.reportsDisplay?.text || ''"
              >
                <License />
              </sidenav-item>
              <sidenav-item
                v-if="getNavigationItem('reports')?.children?.reportsEmail?.enabled"
                :to="getNavigationItem('reports')?.children?.reportsEmail?.path || '/'"
                :text="getNavigationItem('reports')?.children?.reportsEmail?.text || ''"
              >
                <MailBulk />
              </sidenav-item>
            </template>
          </sidenav-collapse-item>

          <!-- Firebase -->
          <sidenav-collapse-item
            v-if="isNavigationItemEnabled('firebase')"
            refer="firebase"
            mini-icon="U"
            :text="getNavigationItem('firebase')?.text || ''"
            :activePaths="[
              getNavigationItem('firebase')?.children?.firebaseUsers?.path || '',
              getNavigationItem('firebase')?.children?.firebaseCustomers?.path || '',
              getNavigationItem('firebase')?.children?.firebaseDashboard?.path || ''
            ]"
          >
            <LogoFirebase />
            <template #nav-child-item>
              <sidenav-item
                v-if="getNavigationItem('firebase')?.children?.firebaseUsers?.enabled"
                :to="getNavigationItem('firebase')?.children?.firebaseUsers?.path || '/'"
                :text="getNavigationItem('firebase')?.children?.firebaseUsers?.text || ''"
              >
                <SupervisedUserCircleRound />
              </sidenav-item>
              <sidenav-item
                v-if="getNavigationItem('firebase')?.children?.firebaseCustomers?.enabled"
                :to="getNavigationItem('firebase')?.children?.firebaseCustomers?.path || '/'"
                :text="getNavigationItem('firebase')?.children?.firebaseCustomers?.text || ''"
              >
                <PersonPinFilled />
              </sidenav-item>
              <sidenav-item
                v-if="getNavigationItem('firebase')?.children?.firebaseDashboard?.enabled"
                :to="getNavigationItem('firebase')?.children?.firebaseDashboard?.path || '/'"
                :text="getNavigationItem('firebase')?.children?.firebaseDashboard?.text || ''"
              >
                <DashboardFilled />
              </sidenav-item>
            </template>
          </sidenav-collapse-item>

          <!-- MQTT Server -->
          <sidenav-item
            v-if="isNavigationItemEnabled('mqttServer')"
            :to="getNavigationItem('mqttServer')?.path || '/'"
            :text="getNavigationItem('mqttServer')?.text || ''"
          >
            <AddressCardRegular />
          </sidenav-item>

          <!-- mobile Accounts -->
          <sidenav-item
            v-if="isNavigationItemEnabled('mobileAccounts')"
            :to="getNavigationItem('mobileAccounts')?.path || '/'"
            :text="getNavigationItem('mobileAccounts')?.text || ''"
          >
            <Mobile />
          </sidenav-item>

          <!-- Android Apps -->
          <sidenav-item
            v-if="isNavigationItemEnabled('androidApps')"
            :to="getNavigationItem('androidApps')?.path || '/'"
            :text="getNavigationItem('androidApps')?.text || ''"
          >
            <ApplicationMobile />
          </sidenav-item>

          <!-- Add Customer -->
          <sidenav-item
            v-if="isNavigationItemEnabled('addCustomer')"
            :to="getNavigationItem('addCustomer')?.path || '/'"
            :text="getNavigationItem('addCustomer')?.text || ''"
          >
            <plus-circle />
          </sidenav-item>
        </ul>
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useLayoutStore } from './../stores/layout'
import {
  UserAlt,
  Bahai,
  Users,
  PlusCircle,
  Android,
  Qrcode,
  MoneyBill,
  Database,
  Key,
  MailBulk,
  FileAltRegular,
  AddressCardRegular,
  MobileAlt
} from '@vicons/fa'
import { License, ApplicationMobile, Mobile } from '@vicons/carbon'
import { LogoFirebase, Server } from '@vicons/ionicons5'
import { appConfig } from '../config/app.config'
import { isNavigationItemEnabled, getNavigationItem } from '../utils/navigationUtils'

import {
  AdminPanelSettingsOutlined,
  PeopleAltRound,
  DevicesOtherTwotone,
  ImportantDevicesFilled,
  ImportantDevicesOutlined,
  NumbersFilled,
  SupervisedUserCircleRound,
  PersonPinFilled,
  DashboardFilled
} from '@vicons/material'
import SidenavItem from './../components/sidebar/SideNavItem.vue'
import SidenavCollapseItem from './../components/sidebar/SideNavCollapseItem.vue'

const layoutStore = useLayoutStore()

onMounted(() => {
  window.addEventListener('resize', showSideNav)
})
onUnmounted(() => {
  window.removeEventListener('resize', showSideNav)
})

const showSideNav = () => {
  if (window.innerWidth < 1200) {
    layoutStore.hideSideNav()
  } else {
    layoutStore.showSideNav()
  }
}
</script>

<style lang="scss">
.notefie {
  &-dashboard {
    &__navigation {
      & ul {
        @apply p-0;
      }
    }
    &__home {
      @apply text-transparent block;
    }
    &__title {
      @apply text-white font-medium ml-4 relative;
      font-size: 18px;
      top: 4px;
    }

    &__logo {
      @apply inline;
      width: 100px;
    }
    &-panel {
      @apply block fixed left-0 top-0 bottom-0 w-full p-0 ml-4 my-4 rounded-2xl z-10;
      box-shadow: none;
      overflow-y: auto;
      max-width: 15.625rem;
      transition: 0.3s ease-in-out;

      &-pinned {
        width: 100%;
      }
      &-hidden {
        width: 0;
      }
    }
  }
}
</style>
